export default "__VITE_ASSET__CwMNyGtW__"